import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  header: {
    boxShadow: "0px 0px 0px 0px",
    padding: ".5rem 3rem",
    // height:"13rem"
  },
  walletButton: {
    borderRadius: "11px",
    border: `2px solid ${theme.palette.secondary.main}`,
    textTransform: "capitalize",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main,
    fontWeight: "600",
    fontSize: "1.4rem",
    padding: "1rem 1.6rem",
    width: "18rem",
    overflow: "hidden",
    "&:hover": {
      background: theme.palette.background.hover,
      // border: `2px solid ${theme.palette.background.hover}`,
    },
  },
}));


